import { render } from "./h5Manage.vue?vue&type=template&id=87092dae&scoped=true"
import script from "./h5Manage.vue?vue&type=script&lang=js"
export * from "./h5Manage.vue?vue&type=script&lang=js"

import "./h5Manage.vue?vue&type=style&index=0&id=87092dae&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87092dae"]])

export default __exports__